import Appsignal from "@appsignal/javascript"
import { plugin as breadcrumbsNetworkPlugin } from "@appsignal/plugin-breadcrumbs-network"

let appsignalInstance: InstanceType<typeof Appsignal> | null = null

export function initAppsignal() {
  const meta = document.querySelector('meta[name="appsignal-frontend-key"]')
  const key = (meta as HTMLMetaElement)?.content
  if (!key) return

  appsignalInstance = new Appsignal({
    key,
    revision: (document.querySelector('meta[name="app-revision"]') as HTMLMetaElement)?.content || "unknown",
  })
  appsignalInstance.use(breadcrumbsNetworkPlugin())

  window.addEventListener("error", (event) => {
    if (event.error && appsignalInstance) appsignalInstance.sendError(event.error)
  })
  window.addEventListener("unhandledrejection", (event) => {
    if (!appsignalInstance) return
    if (event.reason instanceof Error) appsignalInstance.sendError(event.reason)
    else if (event.reason) appsignalInstance.sendError(new Error(String(event.reason)))
  })
}

export function reportError(error: Error | unknown, tags: Record<string, string> = {}) {
  if (!appsignalInstance) return
  const span = appsignalInstance.createSpan()
  span.setError(error instanceof Error ? error : new Error(String(error)))
  if (Object.keys(tags).length > 0) span.setTags(tags)
  appsignalInstance.send(span)
}
